import { render, staticRenderFns } from "./Dashboard.vue?vue&type=template&id=65e4910e"
var script = {}
import style0 from "./Dashboard.vue?vue&type=style&index=0&id=65e4910e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports